// import css from "./popUp.module.css";
// import React from "react";

// const PopUpLibr = React.forwardRef(({ onClick }, ref) => {
//   return (
//     <div className={css.librPopWrap} ref={ref} onClick={onClick}>
//       <p className={css.mainPopPLib}>
//         Зареєструйтеся на сайті як бібліотекар — і отримайте знижку!
//         <br /> Окрім знижки, пропонуємо бібліотекам:
//         <br /> - розіграші подарунків;
//         <br /> - презентації книжок;
//         <br /> - підтримку подій і заходів;
//         <br /> - швидке й зручне замовлення на сторінці "Прайс для гурту".
//         <br />
//         Замовлення для бібліотек доставляємо безплатно!
//       </p>
//     </div>
//   );
// });
// export default PopUpLibr;
// src/components/PopUpLibr.jsx
import React from "react";
import css from "./popUp.module.css";
import { db } from "../../firebase"; // підкоригуй шлях під свій
import { doc, onSnapshot } from "firebase/firestore";

const DOC_ID = "support_libraries_librarians"; // popups/support_libraries_librarians

const PopUpLibr = React.forwardRef(({ onClick, className }, ref) => {
  const [html, setHtml] = React.useState("");
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const unsub = onSnapshot(doc(db, "popups", DOC_ID), (snap) => {
      setLoading(false);
      setHtml(snap.exists() ? snap.data()?.contentHtml || "" : "");
    });
    return () => unsub();
  }, []);

  return (
    <div className={`${css.librPopWrap}`} ref={ref} onClick={onClick}>
      <div
        className={`${css.mainPopPLib}`}
        dangerouslySetInnerHTML={{ __html: loading ? "…" : html }}
      />
    </div>
  );
});

export default PopUpLibr;
